import { AllocateSingleId } from "../AllocateId";
import { GetMasterTableEntries } from "../GetMasterTableEntries";
import { DeleteFromServer, FetchFromServer, SaveToServer } from "../Post";

const MasterTableName = "GAAProductInputDriverChannels";
const FetchRequestType = "GAAProductInputDriverChannelFetchRequest";

export const GetGAAProductInputDriverChannels = async (Ref) => {
  let payload = { GAAProductInputDriverChannelRefs: [Ref] };
  let td = await FetchFromServer(payload, FetchRequestType, []);
  let resultList = GetMasterTableEntries(td, MasterTableName);
  if (resultList.length > 0) {
    return resultList[0];
  }
  return null;
};
 
export const SaveGAAProductInputDriverChannels = async (
  ref,payload,images) => {payload["Ref"] = await AllocateSingleId(ref);
  return await SaveToServer(payload, MasterTableName, images);
};

export const GetGAAProductInputDriverChannelsList = async () => {
  let payload = { GAAProductInputDriverChannelRefs: [] };
  let td = await FetchFromServer(payload, FetchRequestType, []);
  let result = GetMasterTableEntries(td, MasterTableName);
  result = result.sort((a, b) => a.Ref - b.Ref);
  return result;
};

export const DeleteGAAProductInputDriverChannel = async (payload) => {
  return await DeleteFromServer(payload, MasterTableName);
};

export const GAAProductInputDriverChannelListByProduct = async (GAAProductRef) => {
    let payload = { GAAProductRefs: [GAAProductRef]};
    let td = await FetchFromServer(payload, FetchRequestType, []);
    let result = GetMasterTableEntries(td, MasterTableName);
    result = result.sort((a, b) => a.Ref - b.Ref);
    return result;
  };
